var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-changelog"},[_c('div',{staticClass:"m-content"},[_c('div',{staticClass:"m-grid__item m-grid__item--fluid m-wrapper changelog-content",domProps:{"innerHTML":_vm._s(_vm.content)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }